module.exports = __webpack_public_path__ + "static/media/et.a82a19b3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/et.svg
// module id = 110
// module chunks = 0